import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FormattedMessage } from 'react-intl';
import typography from '~/components/styles/typography.module.scss';
import { useRenderingInfo } from '~/contexts/useRenderingInfo';
import { useSERPState } from '~/core/state/SERPStateContext';

interface SectionHeadingProps extends React.HTMLProps<HTMLDivElement> {
    text:
        | string
        | {
              id: string;
              defaultMessage: string;
          };
}

const SectionHeaderComponent: ForwardRefRenderFunction<HTMLDivElement, SectionHeadingProps> = (
    { text, ...props },
    ref
) => {
    const { isMobileVersion } = useRenderingInfo();
    const { config } = useSERPState();

    if (config.mobileLayout === 'tabs' && isMobileVersion) {
        return null;
    }

    return (
        <div role="heading" aria-level={2} className={typography.sectionTitle} ref={ref} {...props}>
            {typeof text === 'string' ? text : <FormattedMessage id={text.id} defaultMessage={text.defaultMessage} />}
        </div>
    );
};

export const SectionHeading = forwardRef(SectionHeaderComponent);
